import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      examRecordList: [],
      loading: false,
      practiceMode: false,
      practiceArId: null,
      practiceRecord: null,
      practiceCategoryList: []
    };
  },
  created() {
    this.syncModeByRoute();
  },
  watch: {
    $route() {
      this.syncModeByRoute();
    }
  },
  methods: {
    parsePositiveInt(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        return null;
      }
      return num;
    },
    syncModeByRoute() {
      const arId = this.parsePositiveInt(this.$route.query.arId);
      this.practiceArId = arId;
      this.practiceMode = arId !== null;
      if (this.practiceMode) {
        this.loadPracticeRecord();
      } else {
        this.loadExamRecordList();
      }
    },
    async loadExamRecordList() {
      this.loading = true;
      try {
        const res = await httpRequest("/app/exam/exam/exams", "get", null);
        if (res !== null && res !== undefined && res.code === 200) {
          this.examRecordList = Array.isArray(res.data) ? res.data : [];
        } else {
          this.examRecordList = [];
        }
      } finally {
        this.loading = false;
      }
    },
    async loadPracticeRecord() {
      if (!this.practiceArId) {
        this.practiceRecord = null;
        this.practiceCategoryList = [];
        return;
      }

      this.loading = true;
      try {
        const res = await httpRequest("/app/train/practice/check/checks", "get", {
          arId: this.practiceArId
        });
        if (res !== null && res !== undefined && res.code === 200 && res.data) {
          this.practiceRecord = res.data;
          this.practiceCategoryList = Array.isArray(res.data.categorys)
            ? res.data.categorys
            : [];
        } else {
          this.practiceRecord = null;
          this.practiceCategoryList = [];
        }
      } finally {
        this.loading = false;
      }
    },
    getPracticeUserName() {
      if (!this.practiceRecord || !this.practiceRecord.user) {
        return "-";
      }
      return this.practiceRecord.user.realName || "-";
    },
    getPracticeMajorName() {
      if (!this.practiceRecord || !this.practiceRecord.major) {
        return "-";
      }
      return this.practiceRecord.major.name || "-";
    },
    getPracticeScoreText() {
      if (!this.practiceRecord || this.practiceRecord.score === null || this.practiceRecord.score === undefined) {
        return "-";
      }
      const num = Number(this.practiceRecord.score);
      if (Number.isNaN(num)) {
        return String(this.practiceRecord.score);
      }
      return Number.isInteger(num) ? `${num}` : num.toFixed(2);
    },
    getPracticeStatusText() {
      if (!this.practiceRecord || this.practiceRecord.score === null || this.practiceRecord.score === undefined) {
        return "待考核";
      }
      const proportion = Number(this.practiceRecord.proportion);
      const passProportion = Number(this.practiceRecord.passProportion);
      if (!Number.isNaN(proportion) && !Number.isNaN(passProportion) && proportion >= passProportion) {
        return "合格";
      }
      return "不合格";
    },
    getPracticeStatusClass() {
      const text = this.getPracticeStatusText();
      if (text === "合格") {
        return "is-pass";
      }
      if (text === "不合格") {
        return "is-fail";
      }
      return "is-pending";
    },
    getCategoryName(row) {
      if (!row || !row.category) {
        return "-";
      }
      return row.category.name || "-";
    },
    getCategoryScore(row) {
      if (!row || row.score === null || row.score === undefined) {
        return "-";
      }
      const num = Number(row.score);
      if (Number.isNaN(num)) {
        return String(row.score);
      }
      return Number.isInteger(num) ? `${num}` : num.toFixed(2);
    },
    formatDateText(dateText) {
      if (!dateText) {
        return "-";
      }
      return String(dateText).replace("T", " ");
    },
    getExamRecordStatus(examRecordIdx) {
      let status = "-";
      const examRecord = this.examRecordList[examRecordIdx];
      if (!examRecord || !examRecord.apply) {
        return status;
      }
      if (examRecord.apply.examType === 0) {
        // 初次考试
        // 理论考试是否已通过
        if (examRecord.score >= examRecord.passScore) {
          // 通过了理论，看论文
          if (examRecord.apply.isCheckPass === 0) {
            if (
              examRecord.apply.paperUrl === null ||
              examRecord.apply.paperUrl === undefined ||
              examRecord.apply.paperUrl.length === 0
            ) {
              status = "等待上传论文";
            } else {
              status = "论文审核中";
            }
          } else if (examRecord.apply.isCheckPass === 1) {
            status = "论文未通过审核";
          } else if (examRecord.apply.isCheckPass === 2) {
            if (
              examRecord.apply.isPracticePass === 0 ||
              examRecord.apply.isPracticePass === null
            ) {
              status = "等待实践分";
            } else if (examRecord.apply.isPracticePass === 1) {
              status = "实践未通过";
            } else if (examRecord.apply.isPracticePass === 2) {
              status = "已通过考试";
            }
          }
        } else {
          status = "未通过理论考试";
        }
      } else {
        // 换证考试
        if (examRecord.score >= examRecord.passScore) {
          status = "已通过考试";
        } else {
          status = "未通过考试";
        }
      }
      return status;
    },
    go2ExamDetailPage(examRecordIdx) {
      const examRecord = this.examRecordList[examRecordIdx];
      this.$router.push({
        path: "/formalExam",
        query: {
          ftId: examRecord.ftId
        }
      });
    }
  }
};
